import type { Uint64 } from "./uint64";

const U32_MASK = 0xffff_ffffn;

function asU32(word: number): bigint {
  return BigInt(word >>> 0);
}

// Canonical sticker-code layout:
//   - word 0 / .low  = least-significant 32 bits
//   - word 1 / .high = most-significant 32 bits
//   - bigint         = (high << 32) | low
export function u64FromLowHighWords(lowWord: number, highWord: number): bigint {
  return (asU32(highWord) << 32n) | asU32(lowWord);
}

export function u64ToLowHighWords(value: bigint): Uint64 {
  const normalized = BigInt.asUintN(64, value);
  return {
    low: Number(normalized & U32_MASK),
    high: Number((normalized >> 32n) & U32_MASK),
  };
}

export function readU64FromWordArray(words: Uint32Array, startWord: number): bigint {
  return u64FromLowHighWords(words[startWord], words[startWord + 1]);
}

export function formatU64WordsAsDecimal(lowWord: number, highWord: number): string {
  return u64FromLowHighWords(lowWord, highWord).toString();
}
